module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06foreword",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("FOREWORD")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/06foreword",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07authornotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("AUTHOR’S NOTE")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/07authornotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08introduction",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/08introduction",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08introduction#fm3sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO USE "), _c('em', [_vm._v("COMMANDO DAD:")])])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/08introduction#fm3sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("CHAPTER 1—THE ADVANCE PARTY: PREPARING BASE CAMP")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO PREPARE BASE CAMP FOR YOUR BT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec1-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Clean")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec1-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec1-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Plan")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec1-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec1-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Prepare")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec1-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec1-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Assign specific areas for your BT and their equipment")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec1-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("ESSENTIALS YOU NEED WHEN BRINGING YOUR BT FROM THE HOSPITAL TO BASE CAMP")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec2-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Clothes")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec2-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec2-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Changing")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec2-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec2-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Transport")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch01-sec2-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("CHAPTER 2—NEW RECRUITS: SURVIVING THE FIRST 24 HOURS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO HOLD YOUR BT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO CHANGE A DISPOSABLE DIAPER")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO CLEAN YOUR BT’S STUMP (UMBILICAL CORD)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("BOTTLE ADMINISTRATION")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("How to sterilize a trooper’s bottle")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("How to make a bottle of breast milk")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("How to make a bottle of formula milk")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("How to heat a bottle of breast milk or formula")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("How to bottle-feed your BT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4-lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("How to burp your BT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec4-lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO PREPARE A BED FOR YOUR BT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO DEAL WITH CRYING")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch02-sec6-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font-kt"
  }, [_vm._v("BEYOND THE FIRST 24 HOURS 48")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("CHAPTER 3—SLEEP AND OTHER NOCTURNAL MISSIONS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("SLEEP ROUTINE: WHAT IT IS, AND HOW AND WHEN TO INTRODUCE IT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec1-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Teach your BT the difference between night and day")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec1-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec1-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Introduce an evening routine")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec1-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec1-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Techniques for establishing a sleep routine")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec1-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("WHAT TO DO WHEN YOUR BT WAKES AT NIGHT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("NAP ROUTINE")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec3-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Common nap cues")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec3-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("SLEEP DEPRIVATION")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Where to get help")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch03-sec4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("CHAPTER 4—KITBAGS: PACKING EVERYDAY ESSENTIALS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("BASIC SURVIVAL KIT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("BASIC SURVIVAL KIT FOR LIGHT-ORDER MISSIONS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("BASIC SURVIVAL KIT FOR MID-TERM DEPLOYMENT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("BASIC SURVIVAL KIT FOR LONG-TERM DEPLOYMENT (OVERNIGHTERS)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("CLOTHING KITBAG FOR LONG-TERM DEPLOYMENT (OVERNIGHTERS)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec5-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Exceptions")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec5-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec5-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Tips for packing")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec5-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec5-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Snacks")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch04-sec5-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("CHAPTER 5—NUTRITION: AN ARMY MARCHES ON ITS STOMACH")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("WEANING: WHAT IT IS, AND HOW AND WHEN TO DEAL WITH IT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec1-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Good first foods to experiment with")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec1-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec1-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Foods to avoid in the first year")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec1-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("SELF-FEEDING: WHAT IT IS, AND HOW AND WHEN TO DEAL WITH IT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO RELIEVE THE PAIN OF TEETHING")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("THE IMPORTANCE OF LEADING FROM THE FRONT AND SETTING A GOOD EXAMPLE")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("THE IMPORTANCE OF TAKING TIME FOR MEALTIME")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("THE IMPORTANCE OF A BALANCED DIET AND PROPER PORTION SIZES")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO PREPARE NUTRITIOUS FOODS FOR THE UNIT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec7-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Good ideas for breakfast")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec7-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec7-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Good ideas for lunch")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec7-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec7-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Good ideas for dinner")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec7-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec7-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("How to introduce variety to prevent boredom")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec7-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO PLAN MEALS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO PREPARE REAL FOOD FAST: HEALTHFUL SNACKS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch05-sec9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("CHAPTER 6—STANDING ORDERS: ESTABLISHING DAILY ROUTINES")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("FEEDING ROUTINE")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("92")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec1-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Common “I am hungry” cues")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec1-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec1-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Common “I am full” cues")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec1-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("MEAL ROUTINE")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("REVEILLE: MORNING ROUTINE")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec3-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Preparing the night before")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec3-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec3-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Waking-up routine")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec3-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec3-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Breakfast")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec3-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec3-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Brushing teeth")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec3-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec3-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Getting dressed")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec3-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("AFTERNOON ROUTINE")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Returning to base camp")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec4-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Entering base camp")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec4-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("99")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("LIGHTS-OUT: EVENING ROUTINE")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("99")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("WEEKEND ROUTINE")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("ROUTINE “FLASHPOINTS”")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch06-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("CHAPTER 7—MORALE: A COMMANDO DAD’S SECRET WEAPON")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter07#ch07-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("WHAT MORALE IS AND HOW TO BUILD IT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter07#ch07-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("106")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter07#ch07-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO MAINTAIN MORALE IN CHALLENGING SITUATIONS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter07#ch07-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("108")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter07#ch07-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO ACCEPT—AND ASK FOR—HELP")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter07#ch07-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("109")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter07#ch07-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("THE IMPORTANCE OF A SUPPORT NETWORK")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter07#ch07-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("CHAPTER 8—CALL THE MEDIC: BASIC FIRST AID AND UNIT MAINTENANCE")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("112")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO ASSEMBLE A BASIC FIRST-AID KIT FOR YOUR TROOPER")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("115")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HIGH TEMPERATURES")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("116")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec2-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("How to deal with a high temperature")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec2-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("117")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("MINOR COMBAT INJURIES")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("117")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Bites and scratches: animal")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("117")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Bites and stings: insect")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Bumps and bruises")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Cuts")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Poison ivy and poison oak")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3-lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Nosebleeds")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec3-lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("119")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("COMMON TROOPER AILMENTS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("119")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Colic (BT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("119")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Cradle cap (BT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("120")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Diaper rash (BT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("120")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Colds (BT/MT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("120")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Constipation (BT/MT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Croup (BT/MT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Dehydration (BT/MT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Diarrhea (BT/MT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Ear infections (BT/MT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("123")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Eye infections and blocked tear ducts (BT/MT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("123")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Flu (BT/MT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("124")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Measles and chickenpox (BT/MT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("124")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Vomiting (BT/MT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec4-lev13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("125")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("CONDITIONS THAT REQUIRE IMMEDIATE ACTION")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec5-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Meningitis (BT/MT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec5-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec5-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Pneumonia (BT/MT)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter08#ch08-sec5-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("127")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("CHAPTER 9—WELCOME TO THE THUNDERBOX: TOILET TRAINING")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("128")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter09#ch09-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("TOILET TRAINING: WHAT IT IS, AND HOW AND WHEN TO DEAL WITH IT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter09#ch09-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("130")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter09#ch09-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("THE GOLDEN RULES OF TOILET TRAINING")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter09#ch09-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("131")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter09#ch09-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("ESSENTIAL KIT LIST FOR TOILET TRAINING")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter09#ch09-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("132")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter09#ch09-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("TOILET-TRAINING ROUTINES")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter09#ch09-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("133")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("CHAPTER 10—ON MANEUVERS: TRANSPORTING YOUR TROOPERS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("134")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("THE GOLDEN RULES OF TROOPER TRANSPORTATION")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("136")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("TRANSPORTING YOUR TROOPERS ON FOOT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("136")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec2-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Baby carrier")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec2-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("137")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec2-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Stroller")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec2-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("138")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec2-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Travel system")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec2-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("139")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec2-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Safety harness")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec2-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("139")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec2-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Buggy board")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec2-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("140")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("TRANSPORTING YOUR TROOPERS BY CAR")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("140")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec3-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Car seat")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec3-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("140")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec3-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Car survival kit")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec3-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("141")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec3-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Car first-aid kit")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec3-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("142")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("TRANSPORTING YOUR TROOPERS ON PUBLIC TRANSPORT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("142")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Bus or subway")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("143")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec4-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Train")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec4-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("143")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec4-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Airplane")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter10#ch10-sec4-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("144")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("CHAPTER 11—ENTERTAINING YOUR TROOPERS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("148")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("THE GOLDEN RULES FOR ENTERTAINING YOUR TROOPERS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("150")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO ENTERTAIN YOUR TROOPERS AT BASE CAMP")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("150")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec2-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Fun base-camp activities")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec2-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("152")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec2-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Toys")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec2-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("152")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec2-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("TV")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec2-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("154")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec2-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Movies")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec2-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("154")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("PLACES TO GO, THINGS TO DO")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("155")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("ABOUT PLAYDATES")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("155")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO ENTERTAIN YOUR TROOPERS IN THE GREAT OUTDOORS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("156")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec5-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("The golden rules for outdoor adventures")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec5-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("156")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec5-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Fun outdoor activities")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec5-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("157")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO ENTERTAIN YOUR TROOPERS ON SHOPPING TRIPS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("158")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("HOW TO ENTERTAIN YOUR TROOPERS WHILE ON MANEUVERS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("159")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec7-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Entertaining when transporting troopers in a stroller")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec7-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("160")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec7-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Entertaining when transporting troopers by car")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec7-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("160")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec7-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Entertaining when transporting troopers on public transport")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter11#ch11-sec7-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("161")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("CHAPTER 12—DEALING WITH HOSTILITIES")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("166")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("THE IMPORTANCE OF ESTABLISHING BOUNDARIES")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("168")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("UNIT REGULATIONS (SETTING RULES)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("169")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("DISCIPLINE: WHAT IT IS, AND WHEN AND HOW TO USE IT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("169")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec3-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Age-appropriate sanctions")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec3-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("171")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec3-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Leading by example")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec3-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("172")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("MT TANTRUMS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("173")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("What is a tantrum?")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("173")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec4-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Avoiding tantrums")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec4-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("174")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec4-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Dealing with tantrums")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec4-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("175")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec4-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("The aftermath")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec4-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("176")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("DISSENSION IN THE RANKS: DEALING WITH HOSTILITY BETWEEN YOU AND YOUR MT")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("176")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec5-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Underlying causes of conflict")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec5-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("179")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("DEALING WITH CONFLICT: PUBLIC HOSTILITIES")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter12#ch12-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("179")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21passing",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("PASSING OUT CEREMONY")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21passing",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("183")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22glossary",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("GLOSSARY")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/22glossary",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("184")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("INDEX")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/23index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("189")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa2c9a96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05toc.vue
// module id = 69
// module chunks = 0